module.exports = __webpack_public_path__ + "img/png2.b4cb81cb.png";